import React, { useEffect, useMemo } from 'react';
import ContainerHeader from '../components/ContainerHeader';
import useSiteAssessment from './CustomHooks/useSiteAssessment';
import {
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  Filter,
  GridComponent,
  Group,
} from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search, Toolbar } from '@syncfusion/ej2-react-grids';
import { Button, setRef } from '@material-ui/core';
import SiteInfoDialog from './components/siteInfoDialog';
import EditSiteTableData from './components/EditSiteTableData';
import MapEditView from './components/googleMapsEditView';
import ConvertToContractModal from './components/ConvertToContract';
import ConfirmationDialog from './components/ConfirmationDialog';
import AddNewSectionInfo from './components/AddSectionData';
import MapRouteView from './components/MapRoutView';
import ImageViewer from './components/ImageViewer';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { Add } from '@material-ui/icons';
import QuickAssessmentModal from './QuickAssessmentModal';
import { MoreVert } from '@mui/icons-material';
import AddNewSiteModal from './AddNewSiteModal';
import { useLocation } from 'react-router-dom';
import { dateTemplate } from '../GenTask/components/SharedFormFields';

class DebugBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught error:', error, info);
  }
  render() {
    if (this.state.hasError) return <div>Error in grid rendering</div>;
    return this.props.children;
  }
}
const contextMenuItems = [{ text: 'Delete Site', target: '.e-content', id: 'DeleteSite' }];

const SiteAssessmentPage = props => {
  const location = useLocation();
  const pageSettings = useMemo(
    () => ({
      pageSize: 30,
      pageSizes: [5, 10, 20, 30, 40],
    }),
    [],
  );
  const filterSettings = {
    type: 'Excel',
  };
  const toolbarOptions = ['Search'];
  const {
    siteAssessmentData,
    getSiteInfo,
    siteInfoData,
    setOpenSiteAssessmentDialog,
    openSiteAssessmentDialog,

    selectedSiteData,
    openSectionEditModal,
    setOpenSectionEditModal,
    handleOpenSiteInfoEditModal,
    selectionSectionData,
    handleSiteAssementSectionEditSave,
    mapData,
    showSiteMap,
    openGoogleMapView,
    setOpenGoogleMapView,
    openConvertToContractModal,
    setOpenConvertToContractModal,
    hadnleOpenConvertToContractModal,
    openConfirmationDialog,
    setOpenConfirmationDialog,
    handleOpenConfirmationDialog,
    confirmationDialogProps,
    handleContractSubmit,
    deleteProductData,
    deleteSpecies,
    saveMapCoordinates,
    updateMapCoordinates,
    deleteMapCoordinates,
    allReqDropDown,
    openNewInfoAddDialog,
    setOpenNewInfoAddDialog,
    defaultValueNewInfoDialog,
    newSectionAddName,
    handleNewInfoSave,
    handleNewSectionAddClick,
    openRouteMapModal,
    setOpenRouteMapModal,
    openRouteView,
    allLocationDetails,
    setSavedRouteDetails,
    getCurrentSiteRouteDetails,
    savedRouteDetails,
    samples,
    samplesData,
    subCompSampleData,
    handleAction,
    handleSubCompSampleData,
    files,
    showFiles,
    closeFiles,
    openFilesDialog,
    handleFileChange,
    handleDeleteFiles,
    viewFile,
    isLoading,
    subCompartments,
    notes,
    handleSiteNotes,
    saveSiteNotes,
    saveSiteRef,
    handleSiteDelete,
    openDeleteModal,
    setOpenDeleteModal,
    selectedSiteId,
    setSelectedSiteId,
    quickAssessmentModal,
    showQuickAssessmentModal,
    closeQuickAssessmentModal,
    step,
    setStep,
    reference,
    setReference,
    handleContinue,
    handleQuickAssessmentSave,
    customerLocations,
    newSiteModal,
    showNewSiteModal,
    closeNewSiteModal,
    handleMapEditorClose,
  } = useSiteAssessment();

  const gridRef = React.useRef(null);
  const [menuPos, setMenuPos] = React.useState(null);

  useEffect(() => {
    // support both query param (new tab) and location state (normal navigation)
    const params = new URLSearchParams(location.search);
    const siteAssessmentId = params.get('siteAssessmentId') || location.state?.siteAssessmentId;

    if (!siteAssessmentId || !gridRef.current) return;

    gridRef.current.search(String(siteAssessmentId));
  }, [siteAssessmentData, location.state, location.search]);

  const handleOpen = event => {
    setMenuPos({
      top: event.clientY,
      left: event.clientX,
    });
  };

  const handleClose = () => {
    setMenuPos(null);
  };

  const contextMenuClick = args => {
    if (args.item.id === 'DeleteSite') {
      console.log('delete', args.rowInfo.rowData.siteAssessmentID);
      setOpenDeleteModal(true);
      setSelectedSiteId(args.rowInfo.rowData.siteAssessmentID);
    }
  };

  function siteInfoLinkTemplate(props) {
    return (
      <Button
        key={`${props.siteAssessmentID}_site`}
        style={{ color: 'blue', fontWeight: 'bold', width: '100%' }}
        onClick={() => getSiteInfo(props)}>
        {props.siteAssessmentID}
      </Button>
    );
  }
  const editOptions = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
  const handleActionBegin = args => {
    if (args.requestType === 'beginEdit' || args.requestType === 'save') {
      setTimeout(() => {
        // safe state updates here
      }, 0);
    }
  };

  const truncateText = props => {
    const field = props?.column?.field;
    const text = props?.[field] ?? '';

    const short = typeof text === 'string' && text.length > 20 ? text.slice(0, 20) + '...' : text;

    return <span title={text}>{short}</span>;
  };

  return (
    <div className="app-wrapper siteWrapper">
      <Box sx={{ mb: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between" gap={2}>
          <Grid item xs>
            <ContainerHeader match={props.match} title="Site Assessment" />
          </Grid>
          <Grid item>
            <Button variant="outlined" color="primary" onClick={showQuickAssessmentModal} startIcon={<Add />}>
              Add Customer Site
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ marginLeft: 16 }}
              onClick={showNewSiteModal}
              startIcon={<Add />}>
              Add Site Assessment
            </Button>
          </Grid>
          <Grid item>
            <IconButton onClick={handleOpen}>
              <MoreVert />
            </IconButton>

            <Menu
              open={Boolean(menuPos)}
              onClose={handleClose}
              anchorReference="anchorPosition"
              anchorPosition={menuPos ? { top: menuPos.top, left: menuPos.left } : undefined}>
              <MenuItem
                component={'a'}
                href="https://flv.apps.services.agriculture.gov.ie/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClose}>
                Forestry License Viewer
              </MenuItem>
              <MenuItem
                component={'a'}
                href="https://www.landdirect.ie/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClose}>
                Land Direct
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Box>

      <div style={{ height: 'calc(100vh - 145px)', width: '100%' }}>
        <DebugBoundary>
          <GridComponent
            ref={gridRef}
            contextMenuItems={contextMenuItems}
            contextMenuClick={contextMenuClick}
            dataSource={siteAssessmentData}
            filterSettings={filterSettings}
            allowPaging={true}
            pageSettings={pageSettings}
            allowSorting={true}
            allowTextWrap={true}
            allowResizing={true}
            allowMultiSorting={true}
            allowReordering={true}
            allowFiltering={true}
            style={{
              minHeight: 'auto !important',
            }}
            actionBegin={handleActionBegin}
            height="100%"
            toolbar={toolbarOptions}>
            <ColumnsDirective>
              <ColumnDirective
                field="siteAssessmentID"
                headerText="Edit Link"
                width="80"
                textAlign="Left"
                template={siteInfoLinkTemplate}
                isPrimaryKey={true}
              />
              <ColumnDirective field="siteDetailsRef" headerText="site Ref" width="100" template={truncateText} />
              <ColumnDirective field="wH_Number" headerText="WH Number" width="100" template={truncateText} />
              {/* <ColumnDirective field="details" headerText="Details" width="100" template={truncateText} /> */}
              <ColumnDirective
                field="submissionDate"
                headerText="Date"
                width="100"
                type="datetime"
                formatter={dateTemplate}
              />
              <ColumnDirective field="siteAssessmentType" headerText="Assessment Type" width="100" template={truncateText} />
              <ColumnDirective field="ownerName" headerText="Owner Name" width="100" template={truncateText} />
              <ColumnDirective field="address" headerText="Address" width="100" template={truncateText} />
              <ColumnDirective
                field="totalVolume"
                headerText="Volume"
                width="90"
                textAlign="Right"
                format="N2"
                editType="numericedit"
                template={truncateText}
              />
              <ColumnDirective field="timber" headerText="Timber Products" template={truncateText} />
            </ColumnsDirective>
            <Inject services={[Page, Sort, Filter, Group, Search, Toolbar, ContextMenu]} />
          </GridComponent>
        </DebugBoundary>
      </div>
      <SiteInfoDialog
        key={siteInfoData?._lastUpdated || Date.now()}
        siteMainData={selectedSiteData}
        open={openSiteAssessmentDialog}
        setOpen={setOpenSiteAssessmentDialog}
        siteInfoData={siteInfoData}
        handelSiteInfoEdit={handleOpenSiteInfoEditModal}
        showSiteMap={showSiteMap}
        deleteProductData={deleteProductData}
        deleteSpecies={deleteSpecies}
        handleNewSectionAddClick={handleNewSectionAddClick}
        openRouteView={openRouteView}
        showFiles={showFiles}
        files={files}
        handleFileChange={handleFileChange}
        handleDeleteFiles={handleDeleteFiles}
        viewFile={viewFile}
        isLoading={isLoading}
        samplesData={samplesData}
        notes={notes}
        handleSiteNotes={handleSiteNotes}
        saveSiteNotes={saveSiteNotes}
        saveSiteRef={saveSiteRef}
        customerLocations={customerLocations}
      />
      <EditSiteTableData
        open={openSectionEditModal}
        setOpen={setOpenSectionEditModal}
        sectionName={selectionSectionData.sectionName}
        sectionData={selectionSectionData.sectionData}
        handleEditSave={handleSiteAssementSectionEditSave}
        subCompartments={subCompartments}
      />
      <MapEditView
        open={openGoogleMapView}
        setOpen={setOpenGoogleMapView}
        sectionData={selectedSiteData}
        mapData={mapData}
        handleEditSave={() => {}}
        saveMapCoordinates={saveMapCoordinates}
        updateMapCoordinates={updateMapCoordinates}
        deleteMapCoordinates={deleteMapCoordinates}
        samples={samples}
        samplesData={subCompSampleData}
        dropDownOptions={allReqDropDown}
        handleAction={handleAction}
        handleSampleData={handleSubCompSampleData}
        isContractCreated={selectedSiteData.isContractCreated}
        onMapClose={handleMapEditorClose}
      />
      <MapRouteView
        allLocationDetails={setSavedRouteDetails}
        mapCordinateDetails={siteInfoData.mapCoordinates}
        open={openRouteMapModal}
        setOpen={setOpenRouteMapModal}
        sectionData={selectionSectionData}
        getRouteDetails={getCurrentSiteRouteDetails}
        routeDetails={savedRouteDetails}
        siteMainData={selectedSiteData.siteAssessmentID}
        isContractCreated={selectedSiteData.isContractCreated}
      />
      <ConvertToContractModal
        open={openConvertToContractModal}
        setOpen={setOpenConvertToContractModal}
        selectedSite={selectedSiteData}
        handleContractConfirmDialog={handleOpenConfirmationDialog}
        handleContractSubmit={handleContractSubmit}
      />
      <ConfirmationDialog
        open={openConfirmationDialog}
        setOpen={setOpenConfirmationDialog}
        confirmationFun={confirmationDialogProps.confirmFnc}
        declineFunction={confirmationDialogProps.cancleFnc}
        confirmationText={confirmationDialogProps.confirmText}
      />
      <AddNewSectionInfo
        open={openNewInfoAddDialog}
        setOpen={setOpenNewInfoAddDialog}
        dropDownOptions={allReqDropDown}
        handleNewAdd={handleNewInfoSave}
        sectionData={defaultValueNewInfoDialog}
        sectionName={newSectionAddName}
        subCompartments={subCompartments}
      />

      <QuickAssessmentModal
        open={quickAssessmentModal}
        onClose={closeQuickAssessmentModal}
        sectionData={selectedSiteData}
        mapData={mapData}
        saveMapCoordinates={saveMapCoordinates}
        deleteMapCoordinates={deleteMapCoordinates}
        step={step}
        setStep={setStep}
        reference={reference}
        setReference={setReference}
        handleContinue={handleContinue}
        onSave={handleQuickAssessmentSave}
      />

      <AddNewSiteModal open={newSiteModal} onClose={closeNewSiteModal} />

      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: { borderRadius: 3, p: 1 },
        }}>
        <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>Delete Metadata</DialogTitle>

        <DialogContent sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: '15px' }}>
            Are you sure you want to this site
            <strong style={{ marginLeft: 4, fontWeight: 'bold' }}>{selectedSiteId || null}</strong>
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpenDeleteModal(false)} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>

          <Button
            variant="contained"
            style={{ backgroundColor: '#FF2400', color: '#fff' }}
            onClick={() => handleSiteDelete(selectedSiteId || null)}
            sx={{ textTransform: 'none' }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* <ImageViewer images={files} openFilesDialog={openFilesDialog} closeFiles={closeFiles} /> */}
    </div>
  );
};

export default SiteAssessmentPage;
